import React, { useEffect, useState } from "react";
import { styles } from "../../stylesheets/simulateurs.css";
import "../../stylesheets/simulateursBis.css";
import Souche_Representant from "./souche.representant";

const Souche = (props) => {
  const [representantsList, setRepresentantsList] = useState([]);
  const [soloResults, setSoloResults] = useState([]);

  useEffect(() => {
    if (soloResults.length < props.donataires) {
      const handle = [...soloResults];
      const handleRepresentants = [...representantsList];
      for (let i = soloResults.length; i < props.donataires; i++) {
        handle.push({});
        handleRepresentants.push({
          handicap: 0,
          beneficiaire_assurance_vie: 0,
          representant_index: i + 1,
        });
      }
      setSoloResults(handle);
      setRepresentantsList(handleRepresentants);
    } else if (soloResults.length > props.donataires) {
      const truncatedResults = soloResults.slice(0, props.donataires);
      const truncatedRepresentants = representantsList.slice(0, props.donataires);
      setSoloResults(truncatedResults);
      setRepresentantsList(truncatedRepresentants);
    }
  }, [props.donataires]);

  function FunctionSetSoloResults(key, value) {
    const updated = [...soloResults];
    updated[key] = value;
    setSoloResults(updated);
    props.functionSetResults(key, value);
  }

  function FunctionSetRepresentantsList(key, value) {
    const updated = [...representantsList];
    updated[key] = value;
    setRepresentantsList(updated);
    const formatedData = {
      souche: props.resultKey + 1,
      representants: updated,
    };
    props.FunctionSetAllRepresentantsList(props.resultKey, formatedData);
  }

  return (
    <div>
      <div style={styles.cardFlexSuccession}>
        {soloResults.map((item, i) => (
          <Souche_Representant
            key={i}
            soloResultKey={i}
            functionSetSoloResults={FunctionSetSoloResults}
            functionSetRepresentantsList={FunctionSetRepresentantsList}
            simulateurid={props.simulateurid}
            montantRepresentant={props.montantRepresentant}
            abattementLegalRepresentant={props.abattementLegalRepresentant}
            lienParenteSuccession={props.lienParenteSuccession}
          />
        ))}
      </div>
    </div>
  );
};

export default Souche;
